<template>
  <div class="contain">
    <div class="header">
      {{ $t('mki18n.t00016') }}
    </div>
    <div class="bank-list">
      <div class="item">
        <span class="label">{{$t('mki18n.t00011')}}</span>
        <div class="text" v-if="payBankData">{{ payBankData.bank_name }}({{bankNum}})</div>
      </div>
      <div class="item">
        <span class="label">{{$t('mki18n.t00012')}}</span>
        <div class="text">
          <img :src="bankForm.bank_img" class="logo" />
          {{ bankForm.receiver_bank_cn }}
        </div>
      </div>
      <div class="item" v-if="accountListEmpty">
        <span class="label">{{ $t("transferInto.lang3") }}</span>
        <div class="text">
          <img :src="transferForm.funds_account_type == 1 ? future : security"
               class="logo" />
          {{ `${transferForm.funds_account_type == 1 ? $t("transferInto.accountName[0]"):$t("transferInto.accountName[1]")}` }}
        </div>
      </div>
    </div>
    <div class="select-box" v-if="!accountListEmpty && (accountList && accountList.length > 0)">
      <div class="ipt-box" :class="{error: !transferForm.account_no && errorStatus && accountList && accountList.length > 0}">
        <div class="ipt-main" @click="accountPicker = true">
          <div class="val-box">
            <span :class="{ placeholder: !transferForm.account_no }" class="label"
            >{{ $t("transferInto.lang3") }}</span
            >
            <div v-if="transferForm.account_no" class="val-text">
              <img :src="transferForm.funds_account_type == 1 ? future : security"
                   class="val-icon" />{{ `${transferForm.funds_account_type == 1 ? $t("transferInto.accountName[0]"):$t("transferInto.accountName[1]")}(${transferForm.account_no})` }}
            </div>
            <span v-if="transferForm.account_no" class="val val-text">
            </span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('transferInto.lang10') }}</p>
      </div>
    </div>
    <!-- 存入币种   -->
    <div class="select-box">
      <div class="ipt-box" :class="{error: !transferForm.remittance_currency && errorStatus}">
        <div class="ipt-main" @click="currencyPicker = true">
          <div class="val-box">
            <span class="label" :class="{ placeholder: !transferForm.remittance_currency }"
            >{{ $t("transferInto.lang2.title") }}</span
            >
            <span class="val" v-if="transferForm.remittance_currency">{{ getSelectText(1,1) }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('transferInto.lang9') }}</p>
      </div>
      <van-popup v-model="currencyPicker" position="bottom" class="picker-ui">
        <van-picker
          :columns="getInitList(1)"
          show-toolbar
          @cancel="currencyPicker = false"
          :default-index="getSelectText(1,2)"
          @confirm="onCurrencyConfirm"
        />
      </van-popup>
    </div>
    <div class="select-box">
      <div :class="{'focus':inputFocusId == 1,error: errorStatus && !transferForm.amount}" class="ipt-box">
        <div class="ipt-main">
          <div class="val-box">
            <span v-if="inputFocusId == 1 || transferForm.amount" class="label">{{ $t("transferInto.lang4") }}</span>
            <van-field
              v-model="transferForm.amount"
              :placeholder="inputFocusId == 1 ? '' : $t('transferInto.lang4')"
              class="val"
              @focus="inputFocus(1)"
              @input="handValidateInput"
              @blur="inputFocusId = null"
              ref="amountField"
            ></van-field>
          </div>
        </div>
        <p v-if="!transferForm.amount && errorStatus" class="error">{{ $t("transferInto.lang5") }}</p>
      </div>
    </div>

    <div class="upload-dom">
      <div class="upload-title">
        {{ $t("investmentExperience.lang1") }}
      </div>
      <van-uploader v-model="fileList" :after-read="afterRead" :before-delete="delImg" :max-count="6" index="1">
        <div class="upload-content">
          <div class="icon-box">
            <img :src="bgColor == 'black-theme' ? addDarkImg : addImg " class="add" />
          </div>
        </div>
      </van-uploader>
    </div>

    <div class="bank-list tips-list">
      <div class="item">
        <span class="label">{{ $t('mki18n.t00017') }}</span>
        <span class="text">{{ $t('mki18n.t00018') }}</span>
      </div>
      <div class="item">
        <span class="label">{{ $t('mki18n.t00019') }}</span>
        <span class="text">{{ $t('mki18n.t00020') }}</span>
      </div>
    </div>
    <div class="foot-pancel">
      <nav-buttons
        :isFixed="false"
        :showPrev="false"
        :disabled="getBtnDisable"
        :nextText="$t('investmentExperience.lang7')"
        @on-next="openPwd"
      />
    </div>

    <div class="foot-tip">
      <div class="tip-title">
        {{ $t("transferIntoAbroad.tips[0]") }}
      </div>
      <div class="tip-content">
        {{ $t("transferIntoAbroad.tips[1]") }}
      </div>
      <div class="tip-content">
        {{ $t("transferIntoAbroad.tips[2]") }}
      </div>
      <div class="tip-content">
        {{ $t("transferIntoAbroad.tips[3]") }}
      </div>
    </div>


    <!--  提交后  -->
    <van-dialog
      v-model="isShowOpenDialog"
      :show-confirm-button="false"
      :showCancelButton="false"
      class="m-open-dialog"
    >
      <div class="dialog-main">
        <div class="dialog-title">
           <img src="../../../assets/images/open-account/tip_icon.png" class="img-dia" />
        </div>
        <p class="text">{{ $t("transferInto.lang6") }}</p>
        <p class="email"
        >{{ $t("transferInto.lang7") }}</p>
        <div class="foot-dia-btn">
          <div class="dia-btn" @click="handNext">{{ $t("transferInto.lang8") }}</div>
        </div>
      </div>
    </van-dialog>


   <!--  账户  -->
    <ActionSheet
      :title="$t('withdrawNew.lang')"
      v-model="accountPicker"
      class="action-sheet-sex"
    >
      <div>
        <div class="sheet-box" 
             v-for="(item,index) in accountList" 
             :key="item.value" 
             @click="selectAccount(item,index)" 
             :class="{
               getlang,
               'active-border':index == activeSelect,
               'disabled': item.type != $route.query.account_type
             }">
          <div class="img-box">
            <img :src="item.type == 1 ? future : security" class="img-logo">
            <span class="title">
              {{ `${ item.type == 1 ? $t("transferInto.accountName[0]"):$t("transferInto.accountName[1]")}(${ item.text })`}}
            </span>
          </div>
          <div class="icon-box">
            <Icon :name="rightOK" class="success-icon" size="22" v-if="index == activeSelect" color="#EA3447"  />
          </div>
        </div>
      </div>
    </ActionSheet>

    <!-- 验证登录密码弹窗 -->
    <van-dialog v-model="checkPasswordShow"
                class="check-password-dialog"
                :title="$t('fail_reason.checkPassword')" show-cancel-button
                :before-close="handleBeforeClose">
      <div class="verifyLoginPassword">
        <Field class="input" v-model="checkPassword" :type="eyeIsOpen ? 'text' : 'password'" >
          <template #button>
            <template v-if="!eyeIsOpen">
              <img
                src="@/assets/images/open-account/light_close.png"
                class="eye lightClose"
                @click="eyeSwitch"
              >
              <img
                src="@/assets/images/open-account/dark_close.png"
                class="eye darkClose"
                @click="eyeSwitch"
              >
            </template>
            <template v-else>
              <img
                src="@/assets/images/open-account/light_open.png"
                class="eye lightOpen"
                @click="eyeSwitch"
              >
              <img
                src="@/assets/images/open-account/dark_open.png"
                class="eye darkOpen"
                @click="eyeSwitch"
              >
            </template>
          </template>
        </Field>
      </div>
    </van-dialog>

    <!--    密码错误-->
    <password-error-prompt
      v-show="pwdErrPromptOption.show"
      :err-code="pwdErrPromptOption.errCode"
      :err-html="pwdErrPromptOption.errHtml"
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    ></password-error-prompt>

  </div>
</template>

<script>
import {
  ActionSheet,
  Dialog, Field,
  Field as VanField, Icon,
  Picker as VanPicker,
  Popup as VanPopup,
  Toast,
  Uploader as VanUploader
} from "vant";
import future from "@/assets/images/open-account/future.png";
import security from "@/assets/images/open-account/security.png";
import addImg from "@/assets/images/id-card-upload-add.png";
import addDarkImg from "@/assets/images/id-card-upload-add-dark.png";
import rightOK from '@/assets/images/app-pages/right_ok.png'
import lrz from "lrz";
import { getBrowser } from "@/utils/browser";
import { closeWebView, changeAccountType } from "@/utils/hybirdMethods";
import navButtons from "../components/navButtons.vue";
import { validateInput } from "@/utils/utils.new";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";

export default {
  components: {
    passwordErrorPrompt, Field,
    ActionSheet,
    Icon, navButtons, VanUploader, VanPicker, VanPopup, VanField, [Dialog.Component.name]: Dialog.Component, },
     data(){
       return {
         future,
         security,
         addImg,
         addDarkImg,
         rightOK,
         transferForm:{
           remittance_bank_id:'',
           remittance_currency:'',
           amount:'',
           voucher:'',
           funds_account_type:'',
           account_no:''
         },
         currencyPicker: false,
         accountPicker: false,
         accountListEmpty: false,
         accountList:[],
         accountType: null,
         inputFocusId: null,
         errorStatus: false,
         fileList: [],
         fileUrlList:[],
         isShowOpenDialog: false,
         activeSelect:-1,
         payBankData: '',
         bankForm: '',

         eyeIsOpen: false,        // 是否明文显示密码
         checkPasswordShow: false,
         checkPassword: '',
         pwdErrPromptOption: {
           show: false,
           errCode: -1,
           errHtml: ""
         },
       }
     },
     created() {
        if(this.$route.query.showType && this.$route.query.showType != 3){
          this.getAccountList();
        }
       const params = {
         id:this.$route.query.id
       }
       this.$apis.getRemittanceDetail(params).then(res =>{
         if(res){
           this.bankForm = res
         }
       });
       const card_id = this.$route.query.card_id;
       if(card_id){
         this.$apis
           .getBankCardInfo({ id: card_id })
           .then(res => {
             this.payBankData = res;
           })
       }
     },
  computed: {
    bankNum(){
      if(this.payBankData && this.payBankData.bank_card.length > 0){
        const text = this.payBankData.bank_card.trim().replace(/\s+/g, '');
        return text.substring(text.length - 4);
      }
      return ''
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    getlang(){
      return localStorage.getItem('localLang')
    },
    getBtnDisable() {
      let btnDis = false;
      const amount = this.transferForm.amount;
      const remittance_currency = this.transferForm.remittance_currency;
      const voucher = this.fileUrlList;
      const accountNo = this.transferForm.account_no
      if (!amount || !remittance_currency || voucher.length == 0) {
        btnDis = true;
      }
      if(this.$route.query.showType && this.$route.query.showType != 3){
        if(!accountNo){
          btnDis = true;
        }
      }
      return btnDis;
    }
  },
     methods: {
       async handleBeforeClose(action, done) {
         // 取消直接关闭弹窗
         if ( action != 'confirm' ) {
           this.checkPasswordShow = false;
           done()
           return false;
         }
         // 确认带上done，作用是控制弹窗是否关闭 done(false)不允许关闭
         this.confirm(done);
       },

       confirm(done) { 
         if (this.checkPassword === "") {
           Toast(this.$t("fail_reason.checkPasswordTips"));
           done(false);
         } else {
           this.$apis
             .checkPasswordFail({
               password: this.checkPassword
             })
             .then((res) => {
               done(false);
               // this.checkPasswordShow = false;
               if (res.code) {
                 done(false);
                 if (res.code === 100174 || res.code === 100173) {
                   this.pwdErrPromptOption.errCode = res.code;
                   this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
                   this.pwdErrPromptOption.show = true;
                   this.$refs["password-error-prompt-el"].show = true;
                   done(false);
                 }
               }else{
                 this.handSubmit();
                 //   提交 下一步
                 done();
               }
             });
         }
       },
       passwordErrorPromptConfirm(errCode) {
         this.pwdErrPromptOption.show = false;
         if (errCode === 100173) {
           this.checkPasswordShow = true;
           this.$refs["custom-field-password"].setInputFocus();
           setTimeout(() => {
             this.$refs["custom-field-password"].setInputFocus();
           }, 500);
         }
       },
       eyeSwitch() {
         this.eyeIsOpen = !this.eyeIsOpen;
       },
      getInitList(e){
        const key = {
          1: this.$t("transferInto.lang2.colums")
        };
        const list = key[e] || [];
        if(!this.payBankData || !this.payBankData.currency_type){
          return list;
        }
        const currencyStr = this.payBankData.currency_type;
        const currencyArr = currencyStr.split(",").map(function(item){
          return item.trim();
        }).filter(function(item){
          return item;
        });
        if(currencyArr.length === 0){
          return list;
        }
        return list.filter(function(item){
          return currencyArr.indexOf(item.value) !== -1;
        });
      },
       getAccountList() {
         this.$apis.getAuthList().then(res => {
            if(res){
              const { accountInfo } = res
              accountInfo.forEach(item =>{
                this.accountList.push({text:item.account_no,value:item.account_no,type:item.account_type})
              })
              this.$nextTick(() =>{
                if(this.accountList.length != 0){
                  this.transferForm.account_no = this.accountList.find(item => item.text == this.$route.query.account_no).text
                  this.transferForm.funds_account_type = this.accountList.find(item => item.text == this.$route.query.account_no).type
                  this.activeSelect = this.accountList.findIndex(item => item.text == this.$route.query.account_no)
                }else{
                  this.accountListEmpty = true;
                }
              })
            }else{
              this.accountListEmpty = true;
            }
         }).catch(err => {
           this.accountListEmpty = true;
         });
       },
       getSelectText(type,i){
         const valueList = this.getInitList(type)
         if(valueList && valueList.length > 0){
           if(i == 1){
             if(type == 1 && this.transferForm.remittance_currency){
               return valueList.find(item => item.value == this.transferForm.remittance_currency).text
             }
           }else{
             if(type == 1 && this.transferForm.remittance_currency){
               return valueList.findIndex(item => item.value == this.transferForm.remittance_currency)
             }
           }
         }
       },
       handValidateInput(value){
         this.transferForm.amount = validateInput(value);
         this.$nextTick(() => {
           this.$refs.amountField.$el.querySelector('input').value = validateInput(value);
         });
       },
       onCurrencyConfirm(e){
         this.currencyPicker = false;
         this.transferForm.remittance_currency = e.value;
       },

       selectAccount(e,i) {
         if(e.type != this.$route.query.account_type) return;
         this.activeSelect = i;
         this.transferForm.funds_account_type = e.type;
         this.transferForm.account_no = e.text;
         this.accountPicker = false;
       },



       inputFocus(id) {
         this.inputFocusId = id;
       },
       async afterRead(file) {
         try {
           file = await lrz(file.file, {
             quality: 0.7
           });
           // eslint-disable-next-line no-empty
         } catch (e) {
         }
         const params = new FormData();
         params.append("file", file.file);
         params.append("put_dir", "gygjqh_money");
         const upLoading = Toast.loading({
           duration: 0,
           forbidClick: true,
           loadingType: "spinner",
           message: this.$t("common.loading_text")
         });
         this.$apis
           .uploadFile(params)
           .then(res => {
             this.fileUrlList.push(res.content);
           })
           .finally(() => {
             upLoading.clear();
           });

       },
       delImg(file) {
         for (let i = 0, len = this.fileList.length; i < len; i++) {
           if (this.fileList[i].content === file.content) {
             this.fileUrlList.splice(i, 1);
             return true;
           }
         }
       },
       openPwd(){
         if(this.getBtnDisable){
           this.errorStatus = true
           return
         }
         this.checkPasswordShow = true;
       },
       handSubmit() {
         const params = {
           ...this.transferForm,
           remittance_bank_id:this.$route.query.id,
           voucher: this.fileUrlList.join(","),
           users_bank_id: this.$route.query.card_id,
         };
         if(!this.transferForm.account_no){
             delete params.account_no
             delete params.funds_account_type
         }

         const toastLoading = Toast.loading({
           duration: 0,
           forbidClick: true,
           loadingType: "spinner",
           message: this.$t("common.loading_text")
         });
         this.$apis.submitTransferInto(params).then(res => {
           if (res.code && res.msg) {
             Toast(res.msg)
             this.checkPasswordShow = false;
           } else {
             this.isShowOpenDialog = true
             toastLoading.clear()
           }
         });
       },
       handNext(){
         this.isShowOpenDialog = false
         const browser = getBrowser()
         const isAPP = browser.isApp;
         if(isAPP){
            changeAccountType(this.transferForm)
            closeWebView()
         }else{
           this.$router.push({ path: "/app-pages/bankTransfer",query:{account_no:this.transferForm.account_no,account_type:this.transferForm.funds_account_type} });
         }
       }
     }
   }
</script>

<style lang="less" scoped>
@import '../styles/styles.less';

.foot-tip {
  margin: 0px 32px;
}
.bank-list{
  &.tips-list{
    margin-top: 20px;
    .item{
      font-size: 24px;
      .label{
        font-size: 24px;
        min-width: 40%;
      }
      .text{
        text-align: right;
      }
    }
  }
  .item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    font-weight: 500;
    .label{
      font-size: 30px;
    }
    .text{
      display: flex;
      align-items: center;
      .logo{
        width: 50px;
        height: 50px;
        object-fit: contain;
        margin-right: 10px;
      }
    }
  }
}
.header {
  padding-top: 24px;
  padding-left: 32px;
  font-size: 32px;
  font-weight: 500;
  color: #17161c;
  padding-bottom: 6px;
}
.select-box{
  margin: 18px 32px;
}
.val-icon{
  width: 36px;
  height: 36px;
  object-fit: contain;
  padding-right: 12px;
  vertical-align: bottom;
}

.upload-dom {
  margin-top: 58px;

  .upload-title {
    font-size: 36px;
    font-weight: 500;
    margin-left: 32px;
    color: #1B1C24;
  }

  .upload-content {
    width: 146px;
    height: 146px;
    border: 2px dashed rgba(23, 22, 28, 0.45);
    border-radius: 8px;
    text-align: center;
    line-height: 186px;
    margin-left: 30px;
    margin-top: 15px;

    .icon-box {
      .add {
        width: 64px;
        height: 64px;
      }
    }

    .show-img {
      width: 156px;
      height: 156px;
    }
  }
  /deep/ .van-uploader__preview-delete-icon {
    top: 0;
    right: 0;
  }

  /deep/ .van-uploader__preview {
    margin: 0px;
  }
}
.foot-pancel{
  margin-top: 30px;
  margin-left: 30px;
  margin-right: 30px;
}

/deep/ .van-uploader__preview-image {
  width: 146px;
  height: 146px;
  border: 2px dashed rgba(23, 22, 28, 0.45);
  border-radius: 8px;
  text-align: center;
  line-height: 196px;
  margin-left: 30px;
  margin-top: 15px;
}
.black-theme{
  .header{
    color: #FFFFFF;
  }
  .ipt-box{
    .val-box{
      color: #ffffff;
    }
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,1);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff !important;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
  .upload-dom{
    .upload-title{
      color: #FFFFFF !important;
    }
    /deep/ .van-uploader__preview-delete{
      background-color: #8C8D8E !important;
    }
  }
  .upload-content{
    border: 2px dashed rgba(255,255,255,0.45);
  }
  /deep/ .van-uploader__preview{
    .van-uploader__preview-image{
      border: 2px dashed rgba(255,255,255,0.45);
    }
  }


}
.val-text{
  font-weight: 500;
}

/deep/ .van-uploader__preview-delete {
    border-radius: 100%;
    width: 32px;
    height: 32px;
    left: 92%;
    background-color: #1B1C24;
}

.sheet-box {
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

</style>
